import React from 'react';
import { Typography } from '@pw-tech/omni-ui';
import Image from 'next/image';
import { InfoIcon } from 'lucide-react';
const Waiting = () => {
  return <article data-sentry-component="Waiting" data-sentry-source-file="Waiting.tsx">
      <div className="relative p-5 border-2 border-[#F7E0B4] bg-[#FEFBE8] rounded-lg flex gap-2 text-center items-center mt-6">
        <div className="flex flex-col items-center self-center gap-2 mx-auto text-center">
          <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/f526c671-e13a-40bc-b21e-4c493a54c23c.svg" alt="waiting" width={40} height={40} data-sentry-element="Image" data-sentry-source-file="Waiting.tsx" />
          <div className="flex items-center gap-2">
            <Typography variant="heading3" weight="semi-bold" className="!text-sm sm:!text-lg" data-sentry-element="Typography" data-sentry-source-file="Waiting.tsx">
              Awaiting Result
            </Typography>
          </div>
          <Typography variant="regular" className="!text-sm !text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="Waiting.tsx">
            Your result will be released very soon...
          </Typography>
        </div>
      </div>

      <div className="flex items-center gap-1 mt-2">
        <div className="flex items-center justify-center flex-shrink-0 ">
          <InfoIcon size={20} data-sentry-element="InfoIcon" data-sentry-source-file="Waiting.tsx" />
        </div>
        <Typography variant="regular" className="!text-sm !text-[#757575]" data-sentry-element="Typography" data-sentry-source-file="Waiting.tsx">
          You will recieve a confirmation of the result on your registered email ID
        </Typography>
      </div>
    </article>;
};
export default Waiting;